

























































import { User } from '@/app/definitions/User'
import { hasPrivilege, resolveFullName } from '@/app/user/whoAmI'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class TedsLauncherProfileInformation extends Vue {
  @Prop()
  public user!: User

  public get fieldStyle(): Record<string, string> {
    return {
      color: this.$teds.options.backgroundFontColor,
      background: this.$teds.options.primaryColor,
      'white-space': 'pre',
    }
  }

  public hasSettingsAccess(user: User): boolean {
    return this.$route.path !== '/settings' && hasPrivilege('BYPASS')(user)
  }

  public resolveLastLogin(user: User): Date {
    return user.lastLogin ? new Date(user.lastLogin) : new Date()
  }

  public get initials(): string {
    const fullName = resolveFullName(this.user)
    const [first, second] = fullName
      .split(' ')
      .map(token => token.charAt(0))
      .join('')
      .toUpperCase()
    return `${first} ${second}`
  }

  private get primarySupervisorName(): string {
    if (!this.user.primarySupervisorId) {
      return 'None'
    } else if (!this.user.primarySupervisorFullName) {
      return `No name found\n(Person ID ${this.user.primarySupervisorId})`
    } else {
      return this.user.primarySupervisorFullName
    }
  }
}
